
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/our-travel-wishlist-for-2022",
      function () {
        return require("private-next-pages/blog/our-travel-wishlist-for-2022.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/our-travel-wishlist-for-2022"])
      });
    }
  